import React from "react";

interface ErrorContentProps {
  title: string;
  message: string | React.ReactNode;
  image: string;
}

const ErrorContent: React.FC<ErrorContentProps> = ({ title, message, image }) => {
    
    return (
        <div className="error-container">
            <div className="error-content">
                <h1>{title}</h1>
                {message}
            </div>
            <div className="error-image">
                <img src={image} alt="Error illustration" className="max-h-80 object-contain" />
            </div>
        </div>
    );
};

export default ErrorContent;